<template>
  <v-card
    class="auth-card mx-auto pa-4 mx-2"
    width="500px"
  >
    <v-card-text>
      <v-form
        ref="formRef"
        class="multi-col-validation"
        @submit.prevent="handleRedefinirSenhaFormSubmit"
      >
        <v-row>
          <v-col cols="12">
            <p class="text-2xl font-weight-semibold text--primary">
              Redefinir senha 🔒
            </p>

            <span>Digite seu e-mail ou celular e enviaremos instruções para redefinir sua senha</span>
          </v-col>
        </v-row>

        <v-text-field
          v-model="request.cpf"
          v-mask="'###.###.###-##'"
          class="my-3"
          dense
          outlined
          label="CPF"
          hide-details="auto"
          validate-on-blur
          :rules="[validators.required]"
        />

        <v-text-field
          v-model="request.email"
          class="mb-3"
          dense
          outlined
          label="E-mail"
          placeholder="email@email.com"
          hide-details="auto"
          validate-on-blur
          :rules="[validators.required, validators.emailValidator]"
        />

        <v-text-field
          v-model="request.celular"
          v-mask="'(##) #####-####'"
          class="mb-3"
          dense
          outlined
          label="Celular"
          hide-details="auto"
          validate-on-blur
          :rules="[validators.required, validators.isTelefoneCelularValido]"
        />

        <div class="d-flex justify-center">
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            @click="goToLogin"
          >
            Voltar
          </v-btn>

          <v-hover v-slot="{ hover }">
            <v-btn
              :color="hover ? '#25D366' : 'primary'"
              type="submit"
            >
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="secondary"
              />
              <span v-else>Enviar</span>
            </v-btn>
          </v-hover>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiChevronLeft } from '@mdi/js'
import { required, emailValidator } from '@core/utils/validation'
import router from '@/router'
import ClienteService from '@/services/modules/ClienteService'
import useCentralStore from '@/store/central'
import useForm from '@/composables/useForm'
import { isTelefoneCelularValido } from '@/utils/validation'

export default {
  setup() {
    const { requestUrl } = storeToRefs(useCentralStore())
    const { formRef, loading, FORM_ERROR, validateForm } = useForm()
    const request = ref({ urlAlias: requestUrl.value, cpf: '', email: '', celular: '' })

    function goToLogin() {
      router.push({ name: 'auth-login' })
    }

    function goToResetarSenha() {
      router.push({ name: 'auth-resetar-senha' })
    }

    async function handleRedefinirSenhaFormSubmit() {
      if (loading.value) return

      if (!validateForm()) {
        Vue.$toast.warning(FORM_ERROR)
        return
      }

      try {
        loading.value = true
        await ClienteService.criarSolicitacaoTrocaSenha(request.value)
        goToResetarSenha()
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,
      request,
      goToLogin,
      handleRedefinirSenhaFormSubmit,
      validators: {
        required,
        emailValidator,
        isTelefoneCelularValido,
      },
      icons: {
        mdiChevronLeft,
      },
    }
  },
}
</script>
